import { useState } from 'react';
import { inject, observer } from 'mobx-react';
import Modal from '@sasaki-dev/react-modal';
import { henshu } from '../../../../henshu';

import Section from '../Section';
import content from '../../store';
import rightArrowIcon from '../../assets/arrow-icon-orange.svg';

import map from '../../assets/map-icon.svg';
import file from '../../assets/file-icon.svg';
import video from '../../assets/video.svg';

const icons = { map, file, video };


const Resource = observer(({ resource }) => (
    <div className="resource-content">
        <div className="icon-wrapper">
            <img src={icons[resource.icon]} alt="Resource icon" aria-hidden="true"/>
            <img src={rightArrowIcon} alt="Continue icon" aria-hidden="true"/>
        </div>

        <henshu.h4 getter={() => resource.title} setter={t => resource.setTitle(t)} />
        {resource.subtitle && (
            <henshu.p getter={() => resource.subtitle} setter={t => resource.setSubtitle(t)} />
        )}
    </div>
));

export default inject('app')(observer(function Resources({ app }) {
    const { instance: store } = content;
    const [modal, setModal] = useState(null);
    const { isEditing } = app;

    return (
        <Section anchor={store.menu[3]} name="Resources">
            <ul>
                {store.resources.map(resource => (
                    <li key={resource.title} style={{ background: resource.icon !== 'file' && resource.image !== '' ? `url(${resource.image})` : '#D9EAE4'}}>
                        {resource.behavior === 'modal' ? <>
                            <button className="unstyled" onClick={() => !isEditing && setModal(resource.href)}>
                                <Resource resource={resource} />
                            </button>

                            <Modal
                                root={document.querySelector('.App')}
                                className={modal === resource.href ? 'active' : ''}
                                onClose={() => setModal(null)}
                            >
                                <header>
                                    <henshu.span
                                        getter={() => resource.title}
                                        setter={t => resource.setTitle(t)}
                                    />
                                </header>

                                <div className="modal-body">
                                    {(isEditing || resource.body !== '') && (
                                        <henshu.div
                                            getter={() => resource.body}
                                            setter={t => resource.setBody(t)}
                                        />
                                    )}

                                    {resource.image.indexOf('.png') === -1 && resource.image.indexOf('.jpg') === -1 ? (
                                        <iframe title={resource.title} src={resource.image} />
                                    ) : (
                                        <henshu.img
                                            alt={resource.title}
                                            getter={() => resource.image}
                                            setter={t => resource.setImage(t)}
                                        />
                                    )}
                                </div>
                            </Modal>
                        </> : (
                            <a href={resource.href} target="_blank" rel="noopener noreferrer">
                                <Resource resource={resource} />
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </Section>
    );
}));
